import TeamMember1 from "../images/Team1.jpeg"

const teamData = [
    { name: "Anna Thomas", department: "Property Management", image: [TeamMember1] },
    { name: "Jane Smith", department: "Sales", image: [TeamMember1] },
    // { name: "Michael Brown", department: "Leasing", image: [TeamMember1] }
  ];
  
  export default teamData;
  